module.exports = __webpack_public_path__ + "img/wechat-payment-white.fd717918.png";